import { z } from 'zod/v4'

// ***
// SCHEMAS
// ***

export const RoleKindSchema = z.enum({
  Member: 'ROLE_MEMBER',
  Guardian: 'ROLE_GUARDIAN',
  Manager: 'ROLE_MANAGER',
  Player: 'ROLE_PLAYER',
  External: 'ROLE_EXTERNAL',
  Admin: 'ROLE_ADMIN',
})

export const UserKindSchema = z.enum({
  Member: 'member',
  Guardian: 'guardian',
  External: 'external',
  Manager: 'manager',
  Player: 'player',
  Admin: 'admin',
})

// ***
// EXPORTED TYPES
// ***

export const RoleKind = RoleKindSchema.enum
export type AllowedRoleKind = z.infer<typeof RoleKindSchema>

export const ExcludeExternalRoleSchema = RoleKindSchema.exclude(['External'])
export type ExcludeExternalRole = z.infer<typeof ExcludeExternalRoleSchema>

export const UserKind = UserKindSchema.enum
export type AllowedUserKind = z.infer<typeof UserKindSchema>

export const ExcludeExternalUserKindSchema = UserKindSchema.exclude(['External'])
export type ExcludeExternalKind = z.infer<typeof ExcludeExternalUserKindSchema>
